import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

/**
 * /create-account is the NHS-or-email method page. It used to follow
 * gapsettings disable_nhs_login. That page stays off: email registration
 * is /create-account-manual.
 */
@Injectable({
  providedIn: 'root'
})
export class RegistrationMethodsPageEnableGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean {
    void this.router.navigateByUrl('/create-account-manual', { replaceUrl: true });
    return false;
  }
}
